import Vue from 'vue';
import Component from 'vue-class-component';
import { MenuItem } from '../model/menu-item';
import { Prop } from 'vue-property-decorator';

@Component({
  template: require('./links.html')
})
export class Links extends Vue {
  @Prop()
  item: MenuItem;

  @Prop()
  level: number;

  @Prop()
  isActive: boolean;

  get levelClass() {
    return `level-${this.level}`;
  }

  href(menuItem: MenuItem) {
    if (menuItem.linkUrl.startsWith('http://') || menuItem.linkUrl.startsWith('https://')) {
      return menuItem.linkUrl;
    } else {
      return menuItem.systemId + '/' + menuItem.linkUrl;
    }
  }

  setMenuItem(item: MenuItem) {
    this.$store.commit('app/setCurrentMenuItem', { menuItemId: item.menuItemId, menuItemText: item.menuItemText, helpUrl: item.helpUrl });
  }

  get menuItemId() {
    return this.$store.getters['app/menuItemId'];
  }
}



// WEBPACK FOOTER //
// src/components/links.ts